/**
 * Where an authenticated session lands when no specific path was requested:
 * after login, on `/`, and on any unmatched route. Kept in one place so the
 * default page moves with a single edit.
 */
export const DEFAULT_LANDING_PATH = "/tablero";
